import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Popover } from 'primeng/popover';

export interface PrestadoresAcreditados27FilterData {
  filAcreditado: number;
  fil180Dias: number;
  filRps: number;
}

const SIM_NAO_OPTIONS: SelectItem[] = [
  { label: 'Sim', value: 1 },
  { label: 'Não', value: 0 },
];

const SITUACAO_RPS_OPTIONS: SelectItem[] = [
  { label: 'Registrado', value: 1 },
  { label: 'Não registrado', value: 0 },
];

@Component({
  selector: 'bl-prestadores-acreditados-2-7-filtro',
  templateUrl: './filtro.component.html',
  styleUrls: ['./filtro.component.scss'],
  standalone: false,
})
export class PrestadoresAcreditados27FiltroComponent implements OnChanges {
  @ViewChild('filterPanel') filterPanel: Popover;

  @Input() data: PrestadoresAcreditados27FilterData;

  @Output() dataChange = new EventEmitter<PrestadoresAcreditados27FilterData>();
  @Output() onChange = new EventEmitter<PrestadoresAcreditados27FilterData>();

  readonly acreditadoOptions = SIM_NAO_OPTIONS;
  readonly acreditado180DiasOptions = SIM_NAO_OPTIONS;
  readonly rpsOptions = SITUACAO_RPS_OPTIONS;

  count = 0;
  label = '';

  localFilAcreditado: number = null;
  localFil180Dias: number = null;
  localFilRps: number = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.updateLabel();
    }
  }

  private updateLabel() {
    this.count = Object.values(this.data ?? {}).filter(valor => valor !== null && valor !== undefined).length;
    this.label = this.count === 0 ? '' : this.count + ' filtro' + (this.count > 1 ? 's' : '');
  }

  onShow($event: Event) {
    this.localFilAcreditado = this.data?.filAcreditado ?? null;
    this.localFil180Dias = this.data?.fil180Dias ?? null;
    this.localFilRps = this.data?.filRps ?? null;
    this.filterPanel.toggle($event);
  }

  onApply() {
    this.data = {
      filAcreditado: this.localFilAcreditado,
      fil180Dias: this.localFil180Dias,
      filRps: this.localFilRps,
    };
    this.updateLabel();
    this.dataChange.emit(this.data);
    this.onChange.emit(this.data);
    this.filterPanel.hide();
  }

  onClear() {
    this.localFilAcreditado = null;
    this.localFil180Dias = null;
    this.localFilRps = null;
    this.data = { filAcreditado: null, fil180Dias: null, filRps: null };
    this.count = 0;
    this.label = '';
    this.dataChange.emit(this.data);
    this.onChange.emit(this.data);
    this.filterPanel.hide();
  }
}
